import { Tooltip } from "@mui/material";
import { eventTypes } from "./eventTypes";

type EventTagProps = {
	event: { Code: string; Name: string };
	show?: "name" | "code";
};

export const EventTypeTag = ({ event, show = "code" }: EventTagProps) => {
	if (!event || !event.Code || !event.Name) {
		return null;
	}
	const backgroundColor = eventTypes.find(
		(e) => e.code === event.Code,
	)?.borderColor;

	if (show === "code") {
		return (
			<Tooltip title={event.Name} arrow>
				<div
					style={{
						width: "26px",
						height: "26px",
						borderRadius: 4,
						display: "inline-flex",
						alignItems: "center",
						justifyContent: "center",
						color: "#fff",
						fontWeight: "bold",
						backgroundColor,
					}}
				>
					{event.Code.charAt(0).toUpperCase()}
				</div>
			</Tooltip>
		);
	}

	return (
		<div
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: "6px",
				fontSize: "0.875rem",
			}}
		>
			<div
				style={{
					width: 8,
					height: 8,
					borderRadius: "50%",
					backgroundColor,
					flexShrink: 0,
				}}
			/>
			<span style={{ fontWeight: 500 }}>{event.Name}</span>
		</div>
	);
};
